import React from "react";
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();

  return (
    <div className="page">
      <h1>Habit Tracker</h1>
      <p>Build better habits. Improve daily.</p>

      <button onClick={() => navigate("/habits")}>
        Get Started
      </button>
    </div>
  );
}

export default Home;
